import React from 'react';
import { useIdioma } from '../../../i18n/idioma';
import { ChevronDown, Lock } from 'lucide-react';
import { TRADES } from '../../../data/trades';

interface TradeSelectProps {
  value: string;
  onChange: (tradeId: string) => void;
}

const TradeSelect: React.FC<TradeSelectProps> = ({ value, onChange }) => {
  const { t } = useIdioma();
  const [open, setOpen] = React.useState(false);
  const current = TRADES.find(oficio => oficio.id === value) ?? TRADES[0];

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-4 h-10 bg-white border border-acero-300 rounded-xl text-sm font-medium text-navy-950 hover:border-acero-400 transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400"
      >
        <span className="flex items-center gap-2">
          <span className="label-ui">Trade</span>
          <span>{current.label}</span>
        </span>
        <ChevronDown size={16} className={`text-acero-400 transition-transform duration-150 ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute left-0 right-0 mt-2 bg-white border border-acero-200 rounded-xl shadow-s3 z-20 overflow-hidden animate-in fade-in slide-in-from-top-2 duration-150">
            {TRADES.map(oficio => {
              const active = oficio.id === value;
              const disabled = !oficio.enabled;
              return (
                <button
                  key={oficio.id}
                  disabled={disabled}
                  onClick={() => { if (!disabled) { onChange(oficio.id); setOpen(false); } }}
                  className={`w-full flex items-center justify-between px-4 py-2.5 text-sm text-left transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 ${
                    disabled
                      ? 'text-acero-300 cursor-not-allowed'
                      : active
                      ? 'bg-brand-50 text-navy-950 font-semibold'
                      : 'text-acero-700 hover:bg-acero-50 hover:text-navy-950 font-medium'
                  }`}
                >
                  <span>{oficio.label}</span>
                  {disabled ? (
                    <Lock size={12} className="text-acero-500" />
                  ) : active ? (
                    <span className="label-ui">{t('comun.activo')}</span>
                  ) : null}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default TradeSelect;
